import api from './api';

const userSettingsService = {
  getSettings: async () => {
    const response = await api.get('/user/settings');
    return response.data;
  },

  updateSettings: async (settings) => {
    const response = await api.put('/user/settings', settings);
    return response.data;
  },

  updateLanguage: async (language) => {
    const response = await api.put('/user/settings', { preferredLanguage: language });
    return response.data;
  }
};

export default userSettingsService;
